// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3WKn2","location":"Header_location__15JeB"};